// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rmc-drawer .rmc-drawer-sidebar {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  box-shadow: none !important;\n  display: flex;\n  justify-content: flex-end;\n}\n@media (min-width: 480px) {\n  .rmc-drawer .rmc-drawer-sidebar {\n    max-width: 375px;\n  }\n}\n.rmc-drawer .rmc-drawer-sidebar .sunzi__sidebar-2nTS0 {\n  width: 100%;\n  height: 100%;\n}\n.rmc-drawer .rmc-drawer-sidebar .sunzi__sidebar-handle-3bEWl {\n  height: 100%;\n  float: left;\n}\n.rmc-drawer .rmc-drawer-sidebar .sunzi__sidebar-handle-close-18b0K {\n  padding: 15px;\n  background: #131313;\n}\n.rmc-drawer .rmc-drawer-sidebar .sunzi__sidebar-content-11Epa {\n  display: inline-block;\n  width: calc(100% - 60px);\n  height: 100%;\n  background: #fff;\n}\n.rmc-drawer .rmc-drawer-overlay {\n  background-color: rgba(0, 0, 0, .7);\n}\n", ""]);
// Exports
exports.locals = {
	"sidebar": "sunzi__sidebar-2nTS0",
	"sidebar-handle": "sunzi__sidebar-handle-3bEWl",
	"sidebarHandle": "sunzi__sidebar-handle-3bEWl",
	"sidebar-handle-close": "sunzi__sidebar-handle-close-18b0K",
	"sidebarHandleClose": "sunzi__sidebar-handle-close-18b0K",
	"sidebar-content": "sunzi__sidebar-content-11Epa",
	"sidebarContent": "sunzi__sidebar-content-11Epa"
};
module.exports = exports;
